module.exports = __webpack_public_path__ + "static/CircularStd-Bold-b17d603e5a3130e0f1912c501d117313.ttf";